import { ResolvedCUEElement } from "@app/layouts/Article/elements";
import { Annotation } from "@app/layouts/Article/StorylineElements/Annotation/Annotation";
import amazonPricingDataLoader, {
  extractAmazonLoader,
} from "@app/utils/amazonPricingDataloader";
import { configSingleStory } from "@pub/config";
import { ProductContent } from "@sphtech/dmg-design-system";
import useSWR from "swr";

import styles from "./product.module.css";
import { productDataDataLoader } from "./ProductIndex";
import { maybeMergeAmazonData } from "./utils";

type Props = {
  element: ResolvedCUEElement;
};

export default function ProductContentElement(element: Props) {
  const { data, isLoading } = useSWR(element.element.relation?.id, (id) =>
    productDataDataLoader.load(id),
  );

  const asins = data?.dealsSource
    .map((deal) => deal.dynamicPricing)
    .filter(Boolean);

  const { data: extractedAmazonData } = useSWR(
    asins?.length ? asins : null,
    async (keys) => {
      return amazonPricingDataLoader.loadMany(keys).then(extractAmazonLoader);
    },
  );

  const handleProsCons = (prosCons?: ResolvedCUEElement[]) => {
    if (configSingleStory.productContent?.hideProsCons || !prosCons) {
      return undefined;
    }
    return prosCons.map((content, index) => (
      <Annotation key={index} element={content} />
    ));
  };

  return (
    !isLoading &&
    data && (
      <div className={styles.detailsContainer}>
        <ProductContent
          {...data}
          dealsSource={maybeMergeAmazonData(
            data.dealsSource,
            extractedAmazonData,
          )}
          pros={handleProsCons(data.pros)}
          cons={handleProsCons(data.cons)}
          detailed={true}
          hidePriceInButton={
            configSingleStory.productContent?.hidePriceInButton
          }
          showBestPrice={configSingleStory.productContent?.showBestPrice}
        />
      </div>
    )
  );
}
